module.exports = __webpack_public_path__ + "media/images/prevention_form/mobbing-2a342d71f65d62f22679ed40fad5fb97.svg";